import React from 'react';
import { WhiteLabelLandingTemplate, CountryConfig } from './WhiteLabelLandingTemplate';

const australiaConfig: CountryConfig = {
  country: 'Australia',
  currencySymbol: 'AU$',
  prices: {
    basic:   'AU$3,900',
    prime:   'AU$7,800',
    elite:   'AU$11,700',
    supreme: 'AU$15,600'
  },
  costComparison: [
    { role: 'Media Buyer',    cost: 'AU$94k – AU$140k yearly' },
    { role: 'SEO Specialist', cost: 'AU$86k – AU$125k yearly' },
    { role: 'Designer',       cost: 'AU$78k – AU$110k yearly' }
  ],
  timezoneQuestion: 'Do you support Australia timezone?',
  timezoneAnswer: 'Yes. Timezone alignment is available for agencies that require it.',
  agencyLabel: 'Australia Agency Partnership Lead',
  thankYouPath: '/whitelabelaustralia/thank-you',
  phonePlaceholder: '+61 (02) 0000 0000',
  cityPlaceholder: 'Sydney, NSW',
  testimonials: [
    {
      quote: 'Their white-label execution has helped us scale client delivery without increasing payroll pressure.',
      author: 'Agency Owner, Sydney',
      result: 'Scaled from 22 to 48 active projects in 6 months'
    },
    {
      quote: 'Fast turnaround, transparent reporting, and strong campaign outcomes. Our clients are happier than ever.',
      author: 'Growth Director, Melbourne',
      result: 'Improved retention and reduced campaign delays by 40%'
    },
    {
      quote: 'They work exactly like an in-house team under our brand. Communication and quality are consistently strong.',
      author: 'Founder, Brisbane',
      result: 'Increased margins while expanding service capacity'
    }
  ],
  docTitle: 'White Label Digital Marketing Execution for Australian Agencies | Mirani Marketing',
  docDescription: 'Scale your digital marketing agency without hiring more staff. Dedicated execution team delivering SEO, AI-SEO, Google Ads, Meta Ads, Creative Production, and Video Editing under your agency brand — built for Australian agencies.'
};

export const AustraliaLandingPage: React.FC = () => <WhiteLabelLandingTemplate config={australiaConfig} />;
export default AustraliaLandingPage;
